import { flatMap, values } from "lodash";
import {
  PlanCell,
  PlanCellCoordinates,
  PlanCellCoordinatesWithOptionalPerson,
  PlanCellWithIndex,
} from "../data/plan";

export interface TableData {
  [day: string]: {
    [meal: string]: { [personId: number]: PlanCell[] };
  };
}

export function getPlanCell(
  tableData: TableData,
  planCellCoordinates: PlanCellCoordinates,
) {
  if (planCellCoordinates.index == undefined) {
    throw new Error("Index für Lookup benötigt");
  }
  return getPlanCells(tableData, planCellCoordinates)[
    planCellCoordinates.index
  ];
}

export function setPlanCell(
  tableData: TableData,
  planCellCoordinates: PlanCellCoordinates,
  planCell: PlanCell,
) {
  if (planCellCoordinates.index == undefined) {
    throw new Error("Index für Lookup benötigt");
  }
  getPlanCells(tableData, planCellCoordinates)[planCellCoordinates.index] =
    planCell;
}

export function getPlanCells(
  tableData: TableData,
  { date, mealInd, personId }: PlanCellCoordinatesWithOptionalPerson,
): PlanCell[] {
  if (!tableData[date]) {
    return [];
  } else if (!personId) {
    return flatMap(values(tableData[date][mealInd]), (x) => values(x));
  } else {
    return tableData[date][mealInd][personId];
  }
}

export function getPlanCellsWithIndex(
  tableData: TableData,
  { date, mealInd, personId }: PlanCellCoordinatesWithOptionalPerson,
): PlanCellWithIndex[] {
  if (!tableData[date]) {
    return [];
  } else if (!personId) {
    return flatMap(values(tableData[date][mealInd]), (x) =>
      values(x).map((planCell, index) => ({ planCell, index })),
    );
  } else {
    return tableData[date][mealInd][personId].map((planCell, index) => ({
      planCell,
      index,
    }));
  }
}

export function getPlanCellsForDateAndMeal(
  tableData: TableData,
  date: string,
  mealInd: string,
) {
  return flatMap(tableData[date][mealInd], (forInd) => values(forInd));
}
